<template>
	<div :class="bankClass">
		<div v-for="(value, index) in bankDetails(bankType)" :key="index" class="card bd-0">
			<div class="card-header pb-0 bd-b-0">
				<h5 class="card-title mb-0">Bank Details for {{ index }} {{ typeLabel }}</h5>
			</div>
			<div class="card-body">
				<div>
					<p v-for="(value, index) in value" :key="index" class="tx-13 tx-color-03 mb-0">{{ value }}</p>
					<p v-if="reference" class="mt-2">Reference - {{ reference }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters({
			bankDetails: 'getIcGroupBankAccountByType',
		}),
	},
	props: {
		bankType: {
			type: String,
			default: 'iclf',
		},
		reference: {
			type: String,
			required: true,
		},
		bankClass: {
			type: String,
			required: false,
		},
		typeLabel: {
			type: String,
			required: false,
			default: 'Investment'
		},
	},
};
</script>

<style>
</style>